// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoBlok_root__kIQ1h"};